import { BoxOfferType } from "@modules/boxOffer/entities/boxOfferTypes"
import { BoxOfferDetailedDtoSchema, BoxOfferItemDtoSchema } from "@modules/boxOffer/gateway/boxOfferDto"
import { CouponDtoSchema } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { PauseDtoSchema } from "@modules/common/pauseObject/gateway/pauseApiDto"
import { PriceObjectDtoSchema } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { PaymentErrorDtoSchema } from "@modules/finances/types/stripeErrorTypes"
import { LightPromoCodeDtoSchema } from "@modules/promoCode/services/promoCodeDto"
import { z } from "zod"

export enum BoxSubscriptionStatus {
  PENDING_PAYMENT = "PENDING_PAYMENT", // User did not complete the buying process
  ACTIVE = "ACTIVE", // User is subscribed
  PENDING_CANCELLATION = "PENDING_CANCELLATION", // User has requested to cancel the subscription
  INACTIVE = "INACTIVE", // User is not subscribed
  PAUSE = "PAUSE", // User or owner has paused the subscription
  PAYMENT_IN_ERROR = "PAYMENT_IN_ERROR", // User has a payment error
  SCHEDULED_ACTIVATION = "SCHEDULED_ACTIVATION", // User has accepted an invitation to join a box in the future
  PROCESSING_PAYMENT = "PROCESSING_PAYMENT", // SEPA payment is in progress
  NEW_BILLING_DATE = "NEW_BILLING_DATE", // The owner has changed the billing date of the subscription
}

export const BoxSubscriptionItemDtoSchema = z.object({
  id: z.string(),
  date: z.string().datetime(),
  subscriptionEndDate: z.string().nullable(),
  status: z.nativeEnum(BoxSubscriptionStatus),
  paidPrice: PriceObjectDtoSchema,
  offer: BoxOfferItemDtoSchema,
  pause: PauseDtoSchema.nullable(),
  coupon: CouponDtoSchema.nullable(),
  usedPromoCode: LightPromoCodeDtoSchema.nullable(),
  minimumCommitmentDate: z.string().datetime().nullish(),
})

// creationDate : le moment où il a lancé le tunnel de paiement (ou prise d'abonnement si prog gratuite)
// periodEndDate : date de prochain renouvellement
// minimumCommitmentDate: date à laquelle le commitment s'arrête
// minimumCommitmentPeriod: nb de lois de commitment à l'achat
// subscriptionDate : date d'activation de la souscription
// subscriptionEndDate : quand la souscription s'arrête (ou renouvellemnt)

export const BoxSubscriptionDetailsDtoSchema = z.object({
  id: z.string(),
  type: z.nativeEnum(BoxOfferType),
  creationDate: z.string().datetime(),
  status: z.nativeEnum(BoxSubscriptionStatus),
  periodEndDate: z.string().datetime().nullable(),
  minimumCommitmentDate: z.string().datetime().nullable(),
  minimumCommitmentPeriod: z.string().nullable(),
  errors: PaymentErrorDtoSchema.nullable(),
  pause: PauseDtoSchema.nullable(),
  coupon: CouponDtoSchema.nullable(),
  deferredDate: z.string().nullable(),
  referencePrice: PriceObjectDtoSchema.nullable(),
  priceObject: PriceObjectDtoSchema.nullable(),
  subscriptionDate: z.string().datetime(),
  subscriptionEndDate: z.string().datetime().nullable(),
  usedPromoCode: LightPromoCodeDtoSchema.nullable(),
  offer: BoxOfferDetailedDtoSchema,
})

export type BoxSubscriptionDetailsDto = z.infer<typeof BoxSubscriptionDetailsDtoSchema>
export type BoxSubscriptionItemDto = z.infer<typeof BoxSubscriptionItemDtoSchema>
